export const findById = (targetId) => {
  return ({ id }) => id === targetId;
};
export const useActiveFindPreset = (presets, activePresetId) => {
  let result;
  presets?.forEach((el) => {
    if (!result) {
      if (el?.children?.length) {
        result = el.children.find(findById(activePresetId));
        result && (result.groupId = el.id);
      } else {
        result = findById(activePresetId)(el) && el;
      }
    }
  });
  return result;
};
